import * as React from 'react';
import {filteredAssign, MessageBar, MessageBarType } from '@fluentui/react';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { IOrderListItem } from '../../../Models/Order/IOrderListItem';
import { MyOrderListView } from './MyOrderListView';
import { useBoolean } from '@fluentui/react-hooks';
import { OrderStateEnum } from '../../../Models/Order/OrderStateEnum';
import * as Services from '../../../Services/Services';
import { IOrderApi } from '../../../Services/API/Order/IOrderApi';
import { OrderDetail } from '../OrderDetail/OrderDetail';
import { IOrder } from '../../../Models/Order/IOrder';

interface IMyOrderListProps {

}

interface IOrderFilter {
    orderId?: number;
    state?: OrderStateEnum;
    name?: string;
    eventName?: string
}

export const MyOrderList: React.FunctionComponent<IMyOrderListProps> = (props) => {

    const [orderItemList, setOrderItemList] = React.useState<IOrderListItem[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [filter, setFilter] = React.useState<IOrderFilter>({ eventName: "", name: "", orderId: 0, state: OrderStateEnum.All });
    const [isPropertiesOpened, setIsPropertiesOpened] = useBoolean(false);
    const [selectedOrderId, setSelectedOrderId] = React.useState<number>();

    const findOrders = async (filter: IOrderFilter) => {
        setIsLoading.setTrue();
        const orderApi = Services.ServicesProvider.GetService<IOrderApi>(Services.OrderApi);
        const result = await orderApi.getOrdersList(filter.orderId, filter.state, filter.name, filter.eventName);
        if (result.isSuccess && result.data) {
            setOrderItemList(result.data);
            setStatusMessage(undefined);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        findOrders(filter);
    }, [filter])

    const refresh = () => {
    }

    const selectOrder = (item: IOrderListItem) => {
        setSelectedOrderId(item.id);
        setIsPropertiesOpened.setTrue();
    }

    return (<>
        <MyOrderListView items={orderItemList} isLoading={isLoading} selectItem={selectOrder} />
        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}        
        {selectedOrderId ?
            <OrderDetail orderId={selectedOrderId}
                isOpen={isPropertiesOpened}
                close={setIsPropertiesOpened.setFalse}
                refresh={refresh}
            /> : null}

    </>)
}

 